/**
 * Character / Unicode inspector — pure, deterministic per-character analysis.
 * Safe to render server-side.
 */

export const MAX_CHARS = 500;

export interface CharInfo {
  char: string;
  /** Unicode code point as a number (also the decimal value). */
  codePoint: number;
  /** Code point in U+XXXX form. */
  hex: string;
  /** UTF-8 bytes, space-separated 2-digit uppercase hex. */
  utf8: string;
}

const encoder = new TextEncoder();

export function inspect(text: string): CharInfo[] {
  // Iterate by code point so astral characters (emoji, etc.) are one entry.
  const chars = [...text].slice(0, MAX_CHARS);
  return chars.map((char) => {
    const codePoint = char.codePointAt(0) ?? 0;
    const utf8 = Array.from(encoder.encode(char), (b) =>
      b.toString(16).padStart(2, "0").toUpperCase(),
    ).join(" ");
    return {
      char,
      codePoint,
      hex: `U+${codePoint.toString(16).toUpperCase().padStart(4, "0")}`,
      utf8,
    };
  });
}
